<template>
  <a-modal v-model:visible="visiblePic" title="查看大图" style="width: 800px;">
    <div class="showBigPic">
      <img :src="bigPic" v-if="bigPic" style="width: 100%;" />
    </div>
    <template #footer></template>
  </a-modal>
</template>
<script>
import { toRefs, inject } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>
